import React from "react";
import { sdsuStageImages } from "../../../utils/imageResources";

import SceneObject from "../../SceneObject";



const Dimploma = React.memo(props => {
    return (
        <SceneObject
            name="Dimploma"
            transform={{
                position: props.transform.position,
                scale: props.transform.scale,
                rotation: props.transform.rotation,
                opacity: 1
            }}
            $imgUrl={sdsuStageImages.DimplomaImg}
        />
    );
});

export default Dimploma;
